import React from "react";
import BeerrallyLogoSvg from "./BeerrallyLogo.svg?react";

interface BeerrallyLogoProps {
  size?: number;
}

const DEFAULT_SIZE = 24;

const BeerrallyLogo: React.FC<BeerrallyLogoProps> = ({ size = DEFAULT_SIZE }) => (
  <BeerrallyLogoSvg width={size} height={size} aria-hidden="true" />
);

export default BeerrallyLogo;
